import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
// Контактные данные
const PHONE_NUMBER = '380508399309';
const TELEGRAM_LINK = `https://t.me/+${PHONE_NUMBER}`;
const WHATSAPP_LINK = `https://wa.me/${PHONE_NUMBER}`;
const EMAIL = 'maximtovkach98@gmail.com';
export function Footer() {
  const {
    t,
    getPath,
    navigate
  } = useLanguage();
  const handleInternalLink = (e: React.MouseEvent<HTMLAnchorElement>, path: string) => {
    e.preventDefault();
    navigate(path);
  };
  return <footer className="w-full py-12 sm:py-16 border-t" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderColor: 'var(--border)'
  }} data-id="element-174">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-175">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-176">
          {/* Services */}
          <div data-id="element-177">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-178">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-179">
              <li data-id="element-180">
                <a href={getPath('#services')} onClick={e => handleInternalLink(e, '#services')} className="hover:underline" data-id="element-181">
                  {t('nav.services')}
                </a>
              </li>
              <li data-id="element-182">
                <a href={getPath('courses/ai-websites')} onClick={e => handleInternalLink(e, 'courses/ai-websites')} className="hover:underline text-neutral-500 font-medium" data-id="element-183">
                  AI Course
                </a>
              </li>
              <li data-id="element-184">
                <a href={getPath('#consultation')} onClick={e => handleInternalLink(e, '#consultation')} className="hover:underline" data-id="element-185">
                  {t('nav.getStarted')}
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-186">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-187">
              {t('footer.company')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-188">
              <li data-id="element-189">
                <a href={getPath('#about')} onClick={e => handleInternalLink(e, '#about')} className="hover:underline" data-id="element-190">
                  {t('footer.aboutLink')}
                </a>
              </li>
              <li data-id="element-191">
                <a href={getPath('referral')} onClick={e => handleInternalLink(e, 'referral')} className="hover:underline" data-id="element-192">
                  {t('nav.referral')}
                </a>
              </li>
              <li data-id="element-193">
                <a href={getPath('#faq')} onClick={e => handleInternalLink(e, '#faq')} className="hover:underline" data-id="element-194">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-195">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-196">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-197">
              <li data-id="element-198">
                <a href={getPath('privacy')} onClick={e => handleInternalLink(e, 'privacy')} className="hover:underline" data-id="element-199">
                  {t('nav.privacy')}
                </a>
              </li>
              <li data-id="element-200">
                <a href={getPath('terms')} onClick={e => handleInternalLink(e, 'terms')} className="hover:underline" data-id="element-201">
                  {t('nav.terms')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-202">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-203">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-204">
              <li data-id="element-205">
                <a href={TELEGRAM_LINK} target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-206">
                  Telegram
                </a>
              </li>
              <li data-id="element-207">
                <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-208">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-209">
                <a href={`mailto:${EMAIL}`} className="hover:underline" data-id="element-210">
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t flex flex-col md:flex-row items-center justify-between gap-4" style={{
        borderColor: 'var(--border)'
      }} data-id="element-211">
          <div className="flex items-center gap-2" data-id="element-212">
            <span className="text-lg sm:text-xl font-bold tracking-tight" style={{
            color: 'var(--text-primary)'
          }} data-id="element-213">
              Jetly Agency
            </span>
          </div>
          <div className="text-xs sm:text-sm text-center" style={{
          color: 'var(--text-muted)'
        }} data-id="element-214">
            © {new Date().getFullYear()} Jetly.agency. {t('footer.rights')}
          </div>
        </div>
      </div>
    </footer>;
}